import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { CampaignService } from './api/campaign.service';
import { CodeBaseService } from './api/codeBase.service';
import { PageConfigService } from './api/pageConfig.service';
import { PagesService } from './api/pages.service';
import { SimulatorService } from './api/simulator.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    CampaignService,
    CodeBaseService,
    PageConfigService,
    PagesService,
    SimulatorService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
